/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.1.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * User began typing in the password field on the enter-password page after
 * signing in with a passkey.
 *
 * Generated from `passkey_enter_password.engage`.
 */
export const engage = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'passkey_enter_password',
    name: 'engage',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * User submitted the password form on the enter-password page after
 * signing in with a passkey.
 *
 * Generated from `passkey_enter_password.submit`.
 */
export const submit = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'passkey_enter_password',
    name: 'submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Password entry failed on the enter-password page after signing in with
 * a passkey.
 *
 * Generated from `passkey_enter_password.submit_frontend_error`.
 */
export const submitFrontendError = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'passkey_enter_password',
    name: 'submit_frontend_error',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * User successfully verified their password on the enter-password page
 * after signing in with a passkey.
 *
 * Generated from `passkey_enter_password.success`.
 */
export const success = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'passkey_enter_password',
    name: 'success',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * User viewed the enter-password page after signing in with a passkey for
 * an existing Sync user (password required to derive sync keys).
 *
 * Generated from `passkey_enter_password.view`.
 */
export const view = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'passkey_enter_password',
    name: 'view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);
